import _ from 'lodash';

export const cleanQuery = query => _.replace(_.deburr(query.toLowerCase()), /\s/g, '');



// WEBPACK FOOTER //
// ./src/services/search/utils.js